import { Button, Dialog } from '@today/ui-primitives'
import type { ReactElement } from 'react'
import { ErrorText } from './product-fields'
import type { Translate } from './product-types'

/**
 * Props for {@link ProductConfirmDialogView}.
 *
 * @property error - A server refusal shown inside the still-open dialog.
 * @property cancelLabel - Overrides the default "Cancel" label (e.g. "Stay").
 */
export interface ProductConfirmDialogViewProps {
	t: Translate
	isOpen: boolean
	title: string
	body: string
	confirmLabel: string
	cancelLabel?: string
	danger?: boolean
	error?: string | null
	onConfirm: () => void
	onCancel: () => void
}

/** A confirm/cancel dialog for the product screens' destructive or guarded actions (organism). */
export function ProductConfirmDialogView(props: ProductConfirmDialogViewProps): ReactElement {
	const { t } = props
	return (
		<Dialog isOpen={props.isOpen} onOpenChange={(open) => (open ? undefined : props.onCancel())} title={props.title}>
			<p className="text-ds-sm text-ds-text">{props.body}</p>
			<ErrorText message={props.error} />
			<div className="mt-3 flex gap-2">
				<Button variant={props.danger ? 'danger' : 'primary'} onPress={props.onConfirm}>
					{props.confirmLabel}
				</Button>
				<Button variant="muted" onPress={props.onCancel}>
					{props.cancelLabel ?? t('actions.cancel')}
				</Button>
			</div>
		</Dialog>
	)
}
